import { RHFInput } from '@talentmesh/ui/components/rhf-input';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@talentmesh/ui/components/tooltip';
import { TypographyH4, TypographyP } from '@talentmesh/ui/components/typography';
import { Info } from 'lucide-react';
import UIStrings from '@/Utils/UIStrings';

const JOB_TITLE_LABEL_ID = 'job-details-job-title-label';

function JobTitleTooltipBody() {
    return (
        <div className="flex max-w-sm flex-col gap-2">
            <TypographyH4 className="text-foreground">{UIStrings.JobTitle}</TypographyH4>
            <TypographyP className="text-foreground">{UIStrings.JobTitleDescription}</TypographyP>
        </div>
    );
}

function JobTitle() {
    return (
        <div className="flex w-full flex-col gap-3">
            <div className="flex flex-row items-center gap-1">
                <span id={JOB_TITLE_LABEL_ID} className="text-foreground text-sm leading-none font-medium">
                    {`${UIStrings.JobTitle}*`}
                </span>
                <TooltipProvider>
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <Info className="text-muted-foreground size-3.5 cursor-pointer" />
                        </TooltipTrigger>
                        <TooltipContent
                            side="bottom"
                            sideOffset={16}
                            hideArrow
                            className="bg-card text-foreground max-w-sm p-4 drop-shadow"
                        >
                            <JobTitleTooltipBody />
                        </TooltipContent>
                    </Tooltip>
                </TooltipProvider>
            </div>
            <RHFInput
                fullWidth
                hideLabel
                name="assessmentName"
                fieldDataCy="jobTitle"
                id="job-details-assessment-name"
                aria-labelledby={JOB_TITLE_LABEL_ID}
            />
        </div>
    );
}

export default JobTitle;
